import { EntityDeleteInput } from 'common/types/globalTypes';
import { differenceBy } from 'lodash';
import { AccessGroupRow } from '../../list';
import { AccessGroups_accessGroups_nodes_accessGroupItems_nodes } from '../../list/__generated__/AccessGroups';
import { ACCESS_GROUP_INITIAL_VALUES } from './constants';
import { AccessGroupItemsValues, AccessGroupValues } from './types';

interface DefaultValueProps {
  accessGroup: AccessGroupRow | undefined;
}
type AccessGroupItems = AccessGroups_accessGroups_nodes_accessGroupItems_nodes;
interface GroupItemsProps {
  existingAccessGroupItems: AccessGroupItems[] | undefined;
  currentAccessGroupItems: AccessGroupItemsValues[];
}

export const getDefaultValues = (props: DefaultValueProps) => {
  const { accessGroup } = { ...props };
  const {
    __typename,
    name,
    description,
    accessGroupItems,
    ...accessGroupFields
  } = {
    ...accessGroup,
  };
  let defaultValues: AccessGroupValues = ACCESS_GROUP_INITIAL_VALUES;
  if (accessGroupFields) {
    defaultValues = {
      name: name || null,
      description: description || null,
      accessGroupItems:
        accessGroupItems?.nodes.map((ele) => ({
          userGroupId: ele.userGroupId,
        })) || [],
    };
  }
  return defaultValues;
};

export const getDeletedItems = (props: GroupItemsProps) => {
  const { existingAccessGroupItems, currentAccessGroupItems } = { ...props };
  const deletedGroupItems =
    currentAccessGroupItems &&
    (differenceBy(
      existingAccessGroupItems,
      currentAccessGroupItems,
      'userGroupId'
    ).map((item) => ({
      id: item.id,
      rowTimestamp: item._rowTimestamp,
    })) as EntityDeleteInput[]);
  return deletedGroupItems;
};

export const getNewGroupItems = (props: GroupItemsProps) => {
  const { existingAccessGroupItems, currentAccessGroupItems } = { ...props };
  const existingGroupItemsArray = existingAccessGroupItems?.map((ele) => ({
    existingAccessGroupId: ele.userGroupId,
  }));
  const newGroupItems =
    currentAccessGroupItems.filter(
      ({ userGroupId: currentUserGroupId }) =>
        !existingGroupItemsArray?.some(
          ({ existingAccessGroupId }) =>
            existingAccessGroupId === currentUserGroupId
        )
    ) || [];
  return newGroupItems;
};
